(function () {
	'use strict';

	const modules = [];

	angular.module('DcDepotModule', modules);
})();
